import React from 'react';
import { LockIcon, ShieldIcon, CreditCardIcon, ClockIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { useCurrency } from '../hooks/useCurrency';
import { handleCartClick, CART_URL } from '../utils/metaPixel';
export function PricingSection() {
  const currency = useCurrency();
  return <section className="py-14 md:py-20 bg-[#1f1f35] relative" data-id="element-209">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-210">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-[#2A2A4A] to-[#1A1A2E] rounded-3xl p-8 md:p-12 shadow-xl border-2 border-rose-500/50 relative overflow-hidden text-center" data-id="element-211">
          {/* Decorative corner accents */}
          <div className="absolute top-0 left-0 w-24 h-24 bg-rose-900/20 rounded-br-full -z-10" data-id="element-212"></div>
          <div className="absolute bottom-0 right-0 w-32 h-32 bg-gold-900/20 rounded-tl-full -z-10" data-id="element-213"></div>

          <h2 className="text-2xl md:text-3xl font-bold text-white mb-6 uppercase tracking-wider" data-id="element-214">
            PRECIO DE LANZAMIENTO:
          </h2>

          <div className="flex justify-center items-baseline mb-4" data-id="element-215">
            <span className="text-6xl md:text-8xl font-heading font-black text-gold-400 tracking-tighter" data-id="element-216">
              $229.99
            </span>
            <span className="text-xl md:text-2xl font-bold text-gold-200 ml-2" data-id="element-217">
              MXN
            </span>
          </div>

          <p className="text-lg text-gray-400 font-medium mb-10" data-id="element-218">
            Pago único · Sin suscripciones · Sin cargos ocultos
          </p>

          <div className="max-w-xl mx-auto flex flex-col items-center" data-id="element-219">
            <a href={CART_URL} onClick={handleCartClick} className="w-full bg-rose-600 hover:bg-rose-700 text-white text-xl md:text-2xl font-bold py-5 px-8 rounded-2xl shadow-[0_10px_20px_rgba(225,29,72,0.3)] hover:shadow-[0_15px_30px_rgba(225,29,72,0.4)] transform hover:-translate-y-1 transition-all duration-300 animate-pulse-slow flex items-center justify-center" data-id="element-220">
              👉 SÍ, QUIERO ACCEDER AHORA
            </a>

            <p className="mt-4 text-sm font-semibold text-green-400 uppercase tracking-widest flex items-center" data-id="element-221">
              <ShieldIcon className="w-4 h-4 mr-1" data-id="element-222" /> Descarga inmediata
            </p>
          </div>

          {/* Urgency Box */}
          <div className="mt-12 bg-rose-500/10 border border-rose-500/30 rounded-xl p-6 max-w-2xl mx-auto" data-id="element-223">
            <div className="flex items-center justify-center text-rose-200 font-bold mb-2" data-id="element-224">
              <ClockIcon className="w-5 h-5 mr-2 animate-bounce" data-id="element-225" />
              <span className="text-lg" data-id="element-226">⏳ OFERTA SOLO POR HOY</span>
            </div>
            <p className="text-gray-300 font-medium" data-id="element-227">
              Reserva válida por <strong data-id="element-228">tiempo limitado</strong>
            </p>
            <p className="text-rose-400 font-semibold text-sm mt-1 underline decoration-rose-400/50 underline-offset-2" data-id="element-229">
              Si sales ahora… puedes perder este precio
            </p>
          </div>

          {/* Trust Icons */}
          <div className="mt-10 flex flex-wrap justify-center gap-6 text-gray-400" data-id="element-230">
            <div className="flex items-center" data-id="element-231">
              <LockIcon className="w-5 h-5 mr-2" data-id="element-232" />
              <span className="text-sm font-medium" data-id="element-233">Pago Seguro</span>
            </div>
            <div className="flex items-center" data-id="element-234">
              <ShieldIcon className="w-5 h-5 mr-2" data-id="element-235" />
              <span className="text-sm font-medium" data-id="element-236">
                Privacidad Garantizada
              </span>
            </div>
            <div className="flex items-center" data-id="element-237">
              <CreditCardIcon className="w-5 h-5 mr-2" data-id="element-238" />
              <span className="text-sm font-medium" data-id="element-239">Tarjetas Aceptadas</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}